/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { TimelineMax } from 'gsap';

import HumAnimation from './HumAnimation';

const propTypes = {
    humReady: PropTypes.string.isRequired,
    humSteps: PropTypes.arrayOf(PropTypes.string).isRequired,
    humEnd: PropTypes.string.isRequired,
};

const defaultProps = {

};

class HumAlong extends Component {
    constructor(props) {
        super(props);

        this.onAnimationReady = this.onAnimationReady.bind(this);
        this.onClickEnd = this.onClickEnd.bind(this);
        this.onClickReady = this.onClickReady.bind(this);

        this.refContainer = null;
        this.refAnimation = null;
        this.refReady = null;
        this.refSteps = [];
        this.refEnd = null;
        this.refSlideTextOnly = null;
        this.refSlideSteps = null;
    }

    componentDidMount() {
        this.timeline = new TimelineMax({
            paused: true,
        });
    }

    onAnimationReady(animations) {
        this.buildTimeline(animations);
    }

    onClickEnd() {
        this.timeline.play('replay');
    }

    onClickReady() {
        this.timeline.paused(false);
    }

    getContainerRef() {
        return this.refContainer;
    }

    getTimeline() {
        return this.timeline;
    }

    buildTimeline(animations) {
        this.timeline.set(this.refReady, {
            autoAlpha: 1,
        });
        this.timeline.fromTo(this.refReady, 0.2, {
            autoAlpha: 1,
        }, {
            autoAlpha: 0,
        });

        this.timeline.fromTo(this.refSlideSteps, 0.2, {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
        }, '-=0.2');

        this.refSteps.forEach((ref, index) => {
            const timeline = new TimelineMax();
            timeline.fromTo(ref, 1, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1,
            }, 0);
            if (typeof animations[`step_${index + 1}`] !== 'undefined') {
                timeline.add(animations[`step_${index + 1}`].paused(false), 0);
            }
            timeline.to(ref, 0.2, {
                autoAlpha: 0,
            }, '-=0.5');
            this.timeline.add(timeline);
        });

        this.timeline.fromTo(this.refSlideSteps, 0.2, {
            autoAlpha: 1,
        }, {
            autoAlpha: 0,
        }, '-=0.2');

        this.timeline.fromTo(this.refEnd, 1, {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
        });

        this.timeline.addPause();
        this.timeline.addLabel('replay');
        this.timeline.to(this.refEnd, 1, {
            autoAlpha: 0,
        });
        this.timeline.to(this.refReady, 1, {
            autoAlpha: 1,
        });
        this.timeline.addCallback(() => {
            this.timeline.progress(0);
            this.timeline.paused(false);
        });
    }

    tick() {
        if (this.refAnimation !== null) {
            this.refAnimation.tick();
        }
    }

    render() {
        const {
            humReady,
            humSteps,
            humEnd,
        } = this.props;
        return (
            <div
                className="hum slide fullscreen"
                ref={(ref) => { this.refContainer = ref; }}
            >
                <div
                    className="slide fullscreen ready"
                    ref={(ref) => { this.refReady = ref; }}
                >
                    <div className="table fullscreen">
                        <div className="cell middle">
                            <button type="button" className="text" onClick={this.onClickReady}>
                                <ReactMarkdown source={humReady} />
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    className="slide fullscreen end"
                    ref={(ref) => { this.refEnd = ref; }}
                >
                    <div className="table fullscreen">
                        <div className="cell middle">
                            <button type="button" className="text" onClick={this.onClickEnd}>
                                <ReactMarkdown source={humEnd} />
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    className="slide fullscreen steps"
                    ref={(ref) => { this.refSlideSteps = ref; }}
                >
                    <div className="table fullscreen">
                        <div className="cell middle">
                            <div className="label">
                                { humSteps.map((step, index) => (
                                    <div
                                        key={`step-${index}`}
                                        className="text"
                                        ref={(ref) => { this.refSteps[index] = ref; }}
                                    >
                                        <ReactMarkdown source={step} />
                                    </div>
                                )) }
                            </div>
                            <div className="animation">
                                <HumAnimation
                                    ref={(ref) => { this.refAnimation = ref; }}
                                    onReady={this.onAnimationReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HumAlong.propTypes = propTypes;
HumAlong.defaultProps = defaultProps;

export default HumAlong;



// WEBPACK FOOTER //
// ./components/partials/HumAlong.jsx